import { Auth } from "aws-amplify"

export const getAccessToken = async () => {
    try{
        let accessToken = null;

        const googleAuth = JSON.parse(localStorage.getItem("googleAuth"))
        if(googleAuth && 'token' in googleAuth && 'email' in googleAuth) {
            accessToken = googleAuth.token
        } else {
            const auth = await Auth.currentSession();
            accessToken = auth.accessToken.jwtToken;
        }

        return accessToken;
    }catch(e){
        console.error("Error getting access token: ", e);
        return null
    }
}